export const isOSX = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
